export default "__VITE_ASSET__CaK9p2Hp__"